<template>

	<div v-if="(isDashboard == undefined || isDashboard == 0) && $root.isMobile == false">

		<!-- Page header -->
		<div class="page-header page-header-light shadow">
			<!-- breadcrumb -->
			<div class="page-header-content d-lg-flex">
				<div class="d-flex">
					<h4 class="page-title mb-0">
						<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
						<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="init()"> Task</a>
						<span class="hidden-xs ms-1">\</span>
						<span class="text-muted ms-1"><Translate :path="'dizionario.base.ELENCO'"></Translate> Task Manager</span>
					</h4>
					<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
						<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
					</a>
				</div>
				<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
					<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

						<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" @click="creaTask">
							<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
							<div class="me-auto me-lg-1 ms-1">
								<div class="fs-sm text-muted mb-0">
									<Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Task
								</div>
								<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
							</div>
						</a>

						<div class="vr flex-shrink-0 my-2 mx-3"></div>

						<div class="d-inline-flex float-end mt-sm-0">
							<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="modificaOpzione(57)" title="Opzioni ToDo" data-bs-toggle="tooltip" data-bs-placement="left">
								<i class="ph-lightning"></i>
							</a>
							<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(57)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
								<i class="ph-flag"></i>
							</a>
							<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(57)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
								<i class="ph-question" style="color: red;"></i>
							</a>
						</div>
					</div>
				</div>
			</div>
			<!-- /breadcrumb -->

			<!-- Profile navigation -->
			<div class="navbar navbar-expand-lg border-top py-1">
				<div class="container-fluid">
					<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
						<li class="nav-item me-1" role="presentation">
							<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{ active: activeTab == 'Personali' }" @click="activeTab = 'Personali'" tabindex="-1">
								<div class="d-flex align-items-center mx-lg-1">
									<i class="icon-menu7"></i>
									<span class="hidden-lg ms-1"> Personali</span>
									<span class="hidden-xs ms-1"> Task personali <span class="badge bg-yellow text-black position-absolute top-0 end-0 translate-middle-top zindex-1 rounded-pill mt-1 me-1">{{ totalePersonali }}</span></span>
								</div>
							</a>
						</li>
						<li class="nav-item me-1" role="presentation">
							<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{ active: activeTab == 'Condivise' }" @click="activeTab = 'Condivise'" tabindex="-1">
								<div class="d-flex align-items-center mx-lg-1">
									<i class="icon-menu7"></i>
									<span class="hidden-lg ms-1"> Condivise</span>
									<span class="hidden-xs ms-1"> Task condivise <span class="badge bg-yellow text-black position-absolute top-0 end-0 translate-middle-top zindex-1 rounded-pill mt-1 me-1">{{ totaleCondivise }}</span></span>
								</div>
							</a>
						</li>
						<li class="nav-item me-1" role="presentation">
							<a href="#tasks-c" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1" v-on:click="statisticheStartup();">
								<div class="d-flex align-items-center mx-lg-1">
									<i class="ph-activity me-2"></i>
									<span class="hidden-lg ms-1">Stats.</span>
									<span class="hidden-xs ms-1">
										<Translate :path="'dizionario.base.BTN_STATISTICHE'"></Translate>
									</span>
								</div>
							</a>
						</li>
					</ul>

					<div class="navbar-collapse collapse" id="profile_nav">
						<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
							<li class="nav-item dropdown ms-lg-1">
								<div class="btn-group">
									
								</div>
							</li>
							<li class="nav-item">

							</li>
						</ul>
					</div>

				</div>
			</div>
			<!-- /profile navigation -->

		</div>
		<!-- /page header -->

		<!-- Content area -->
		<div class="content content-1 table-cms-wrapper">
			<div class="tab-content flex-1 order-2 order-lg-1">

				<div class="tab-pane fade active show">
					<div class="row">
						<div class="col-md-3 col-lg-3">
							<div class="sidebar sidebar-component sidebar-expand-lg bg-transparent shadow-none">
								<div class="sidebar-content">
									<div class="card">
										<div class="card-header border-bottom text-center">
											<input type="text" class="form-control bg-transparent rounded-pill mb-2" placeholder="Search">
										</div>
										<div class="card-body">
											<ul class="nav nav-sidebar" data-nav-type="accordion">
												<li class="nav-item-header text-muted fw-bold">Principali</li>
												<li class="nav-item" v-for="cat in categorieBase" :key="cat.ID_CATEGORIA">
													<a href="#" class="nav-link" :class="{ 'bg-light border': categoriaSelezionata?.ID_CATEGORIA == cat.ID_CATEGORIA, 'border-primary': hoveredCategoryId == cat.ID_CATEGORIA }" style="border: none; background-color: transparent; cursor: pointer;" @click="selezionaCategoria(cat)">
														<i :class="['fad', cat.ICONA?.toLowerCase()]" :style="{ color: cat.COLORE, fontSize: '1.1rem', minWidth: '20px' }"></i>
														<span class="text-truncate" style="font-size: 0.95rem;">{{ cat.NOME }}</span>
													</a>
												</li>
												<li class="nav-item-header text-muted fw-bold">Le Mie Categorie</li>
												<li class="nav-item" v-for="cat in categoriePersonalizzate" :key="cat.ID_CATEGORIA">
													<a href="#" class="nav-link" :class="{ 'bg-light border': categoriaSelezionata?.ID_CATEGORIA == cat.ID_CATEGORIA, 'border-primary': hoveredCategoryId == cat.ID_CATEGORIA }" style="border: none; background-color: transparent; cursor: pointer;" @click="selezionaCategoria(cat)">
														<i :class="['fad', cat.ICONA?.toLowerCase()]" :style="{ color: cat.COLORE, fontSize: '1.1rem', minWidth: '20px' }"></i>
														<span class="text-truncate" style="font-size: 0.95rem;">{{ cat.NOME }} <small v-show="cat?.USERNAME">({{cat.USERNAME}})</small></span>
													</a>
												</li>
												<li class="nav-item-header text-muted">&nbsp;</li>
											</ul>
										</div>
										<div class="card-footer border-top text-center">
											<button class="btn btn-flat-secondary btn-sm me-2" @click.prevent="init(null)">
												<i class="ph-chats ph-sm me-1"></i>Mostra tutti i Task
											</button>

											<button class="btn btn-flat-secondary btn-sm float-end" @click.prevent="creaCategoria">
												<i class="ph-chats ph-sm me-1"></i>Crea nuova Categoria
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-9 col-lg-9">

							<div class="card shadow mb-xs-3 mb-lg-0">
								<div class="card-header d-lg-none p-1">
									<div class="d-grid gap-2">
										<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
											MOSTRA FILTRI
										</a>
									</div>
								</div>
								<div class="collapse show" id="collapse-all" style="">
									<div class="card-body pb-0">
										<div class="alert alert-2 alert-secondary border-0">
											<form autocomplete="off" action="#" id="task-a">
												<div class="row">
													<div class="col-6 col-md-2 col-lg-2">
														{{ categoriaSelezionata.ID_CATEGORIA > 0 ? categoriaSelezionata.NOME : 'Nessuna Categoria Selezionata'  }}
													</div>
													<div class="col-6 col-md-2 col-lg-2 mbx-1"
														v-if="activeTab == 'Condivise'">
														<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Utente" v-model="search.UTENTE.VALUE" :tabindex="7" />
													</div>
													<div class="col-6 col-md-2 col-lg-2 mbx-1">
														<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Titolo" v-model="search.TITOLO.VALUE" :tabindex="7" />
													</div>
													<div class="col-6 col-md-2 col-lg-2 mbx-1">
														<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Descrizione" v-model="search.DESCRIZIONE.VALUE" :tabindex="7" />
													</div>
													<div class="col-6 col-md-2 col-lg-2 mbx-1">
														<Datepicker :dim="'mdd'" placeholder="Data scadenza" v-model="search.DATA_SCADENZA.VALUE" model-type="dd/MM/yyyy HH:mm" :formats="{ input: 'dd/MM/yyyy HH:mm' }"></Datepicker>
													</div>
													<div class="col-6 col-md-2 col-lg-2 mbx-1">
														<select class="form-select  form-select-sm" v-model="search.PRIORITY.VALUE">
															<option value="">Nessuna</option>
															<option value="0">Bassa</option>
															<option value="1">Media</option>
															<option value="2">Alta</option>
														</select>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>

								<div class="card-body box-card mt-0 mb-0" id="box-card">
									<div class="div_table_resp tableFixHead" id="tableFixHead">
										<table class="table tasks-list border-top">
											<thead class="sticky-top">
												<tr style="background-color: #ffffff;">
													<th class="table-head-sm" style="width:2%; padding: 25px 0px;"></th>
													<th class="table-head-sm" style="width:31%;"> Titolo<br>Descrizione</th>
													<th class="table-head-sm" style="width:20%;" v-if="$root.isGod || activeTab == 'Condivise'"> <span>Utenti </span></th>
													<th class="table-head-sm" style="width:20%;" v-if="activeTab == 'Personali'"> <span>Categoria </span> </th>
													<th class="table-head-sm" style="width:10%;"> Priorità </th>
													<th class="table-head-sm" style="width:9%;"> Scadenza </th>
													<th class="table-head-sm" style="width:8%;"> Azioni </th>
												</tr>
											</thead>
											<template v-for="section in orderedSections" :key="section.key">
												<tbody>
													<tr class="table-light" @click="section.toggle()" style="height: 40px; cursor: pointer;">
														<td colspan="8" class="fw-semibold">
															<span>{{ section.label }} ({{ section.tasks.length }})</span>
															<i :class="section.show ? 'fa fa-chevron-up float-end' : 'fa fa-chevron-down float-end'"></i>
														</td>
													</tr>
												</tbody>

												<tbody v-if="section.show">
													<tr v-for="task in section.tasks" :key="task.ID_TASK">
														<td class="td-class text-center" style="padding: 15px 10px !important;">
															<span class="footable-toggle"></span>
															<span
																v-if="$root.isGod && task.UTENTI_ASSEGNATI?.length == 1 && task.UTENTI_ASSEGNATI[0].ID_UTENTE == $root.utente.ID_UTENTE">
																<input type="checkbox" class="form-check-input me-1"
																	style="width: 15px; height: 15px;"
																	:checked="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : false"
																	:disabled="false"
																	@change.stop="toggleCompletamento(task)" />
															</span>

															<span v-else-if="$root.isGod">
																<button class="btn btn-sm btn-outline-success me-1"
																	@click.stop="toggleCompletamento(task)"
																	title="Completa task per uno o più utenti">
																	<i class="fa fa-check-square-o"></i>
																</button>
															</span>

															<span v-else>
																<input type="checkbox" class="form-check-input me-1"
																	style="width: 15px; height: 15px;"
																	:checked="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : false"
																	:disabled="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : true"
																	@change.stop="toggleCompletamento(task)" />
															</span>
														</td>
														<td class="td-class">
															<i v-if="task.PROMEMORIA == 1" class="fa fa-bell text-warning me-1"></i><span class="text-primary fw-bold" :style="{ textDecoration: task.UTENTE_LOGGATO?.COMPLETATA ? 'line-through' : 'none' }">{{ task.TITOLO }}</span>
															<br>
															<span v-if="task.ITEM_ASSEGNATI?.length" class="text-info fw-bold fs-xs" v-html="formatItemsFormatted(task.ITEM_ASSEGNATI)"></span>
															<span class="text-muted">{{ task.DESCRIZIONE }}</span>
														</td>
														<td v-if="$root.isGod || activeTab == 'Condivise'" class="td-class fs-sm">
															<!-- Sezione UTENTI ASSEGNATI solo se Condivisa -->
															<div class="d-flex align-items-center flex-wrap" style="gap: 0.3rem;">
																<div v-for="utente in task.UTENTI_ASSEGNATI" :key="utente.ID_UTENTE"
																		class="d-flex align-items-center avatar-wrapper"
																		:class="{ 'expanded': avatarEspansi[task.ID_TASK] == utente.ID_UTENTE }"
																		@click.stop="toggleAvatar(task.ID_TASK, utente.ID_UTENTE)">
																		<img v-if="utente.URL_AVATAR" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" alt="avatar" class="avatar-img" />
																		<i v-else class="fa fa-user text-secondary avatar-img d-flex align-items-center justify-content-center"></i>

																	
																		<transition name="fade-expand">
																			<span
																				v-if="avatarEspansi[task.ID_TASK] == utente.ID_UTENTE"
																				class="ms-2 username"
																				@mouseenter="showTooltipIfItem(task, utente.ID_UTENTE)"
																				@mouseleave="hoverUtente = null"
																				:style="{ textDecoration: utente.COMPLETATA ? 'line-through' : 'none', position: 'relative' }">
																				@{{ utente.USERNAME }}

																				<div v-if="hoverUtente == utente.ID_UTENTE"
																					class="tooltip-dettagli shadow-sm p-2 bg-white border rounded"
																					style="position: absolute; top: 100%; left: 0; z-index: 1000; min-width: 150px;">
																					<ul class="mb-0 ps-3">
																						<li v-for="item in dettagliItemPerUtente(task, utente.ID_UTENTE)"
																							:key="item.item"
																							class="d-flex align-items-center gap-2">
																							<span>Item {{ item.item
																							}}</span>
																							<input type="checkbox"
																								:checked="item.completata"
																								:disabled="!$root.isGod && utente.ID_UTENTE !== $root.utente.ID_UTENTE || (item.completata && !$root.isGod)"
																								@change="completaItem(task, utente.ID_UTENTE, item.item, !item.completata)" />
																						</li>
																					</ul>

																				</div>
																			</span>
																		</transition>
																	</div>
															</div>
														</td>
														<td v-if="activeTab == 'Personali'" class="td-class fs-sm">
															<select name="status" class="form-select" v-model="task.FK_ID_CATEGORIA" @change="onChangeCategoria(task)">
																<option value="">Seleziona Categoria</option>
																<option v-for="cat in arrayCategories" :key="cat.ID_CATEGORIA" :value="cat.ID_CATEGORIA">{{ cat.NOME }}</option>
															</select>
														</td>
														<td class="td-class fs-sm">
															<a class="link-danger d-inline-flex align-items-center">
																<div class="rounded-pill p-1 me-2" :class="{ 'bg-danger': task.PRIORITY == 2, 'bg-warning': task.PRIORITY == 1, 'bg-success': task.PRIORITY == 0 }">
																</div>
																<span :class="{ 'text-danger': task.PRIORITY == 2, 'text-warning': task.PRIORITY == 1, 'text-success': task.PRIORITY == 0 }">
																	{{ task.PRIORITY == 0 ? 'Bassa' : task.PRIORITY == 1 ? 'Media' : task.PRIORITY == 2 ? 'Alta' : 'Nessuna' }}
																</span>
															</a>
														</td>
														<td class="td-class fs-sm">
															<span class="badge bg-light text-secondary small">
																{{ task.DATA_SCADENZA }}
															</span>
														</td>
														<td class="td-class fs-sm">
															<a href="#" class="text-primary me-2" @click.stop.prevent="modificaTask(task)">
																<i class="fa fa-pencil"></i>
															</a>
															<a href="#" class="text-danger me-2" @click.stop.prevent="eliminaTask(task)">
																<i class="fa fa-trash"></i>
															</a>
															<a href="#" class="me-2" :class="task.UTENTE_LOGGATO?.FISSATA ? 'text-warning' : 'text-muted'" @click.stop.prevent="toggleFissata(task, task.UTENTE_LOGGATO)" :title="task.UTENTE_LOGGATO?.FISSATA ? 'Sblocca dalla cima' : 'Fissa in cima'">
																<i :class="task.UTENTE_LOGGATO?.FISSATA ? 'fa fa-ban' : 'fa fa-thumbtack'"></i>
															</a>
															<a href="#" class="text-warning me-2" @click.stop.prevent="gestisciPromemoria(task)">
																<i class="fa fa-bell"></i>
															</a>
														</td>
													</tr>
												</tbody>
											</template>

										</table>
									</div>

									<div class="row page-bottom">
										<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
											<div style="position: relative; top: 10px;">
												<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">
													PERSONALI: {{ totalePersonali }}
												</span>
												<span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">
													CONDIVISE: {{ totaleCondivise }}
												</span>
											</div>

										</div>
										<div class="col-9 col-md-6" :tabindex="27">
											<div class="float-end pag-mobile">
												<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
											</div>
										</div>
										<div class="col-3 col-md-1" :tabindex="28">
											<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="25">25</option>
												<option value="50">50</option>
												<option value="75">75</option>
												<option value="100">100</option>
												<option value="250">250</option>
												<option value="500">500</option>
											</select>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

			</div>
		</div>

	</div>
	<div v-else-if="isDashboard == 1 || ($root.isMobile == true && isDashboard == undefined)" >
		<div>
			<div class="flex-1">
				<div class="">
					<div class="card-header bg-transparent border-0 d-flex justify-content-between align-items-center">
						<!-- Tabs -->
						<div class="nav nav-tabs card-header-tabs">
							<button class="nav-link" :class="{ active: activeTab == 'Personali' }" @click="activeTab = 'Personali'" style="padding: 0.3rem 0.5rem !important;">
								<i class="fas fa-user me-1"></i> Personali
							</button>
							<button class="nav-link" :class="{ active: activeTab == 'Condivise' }" @click="activeTab = 'Condivise'" style="padding: 0.3rem 0.5rem !important;">
								<i class="fas fa-share-alt me-1"></i> Condivise
							</button>
						</div>

						<!-- Menu Dropdown -->
						<div class="dropdown" style="top: 5px !important;">
							<a type="button" data-bs-toggle="dropdown" aria-expanded="false">
								<i class="fa fa-bars"></i>
							</a>
							<ul class="dropdown-menu dropdown-menu-end">
								<li>
									<a class="dropdown-item" href="#" @click="apriSelezioneCategoria">
										<i class="fa fa-folder-open me-2"></i> Seleziona categoria
									</a>
								</li>
								<li>
									<a class="dropdown-item" href="#" @click="toggleFilterCollapse">
										<i class="fa fa-filter me-2"></i> Filtri avanzati
									</a>
								</li>
								<li>
									<a class="dropdown-item" href="#" @click="$root.openRoute('/Task')">
										<i class="fa fa-check me-2"></i> Mostra tutte
									</a>
								</li>
							</ul>
						</div>
					</div>

					<!-- Body con scroll -->
					<div class="card-body" style="overflow-y: auto; min-height: 500px; max-height: 500px; max-width: 400px; padding-top: 10px;">
						<input type="text" class="form-control bg-transparent rounded-pill mb-2" placeholder="Search" v-model="search.TITOLO.VALUE" />

						<!-- Mostra categoria selezionata -->
						<div v-if="categoriaSelezionata?.ID_CATEGORIA" class="mb-2 d-flex align-items-center px-2 gap-2">
							<i :class="['fa', categoriaSelezionata.ICONA?.toLowerCase()]" :style="{ color: categoriaSelezionata.COLORE || '#999', fontSize: '1rem' }"></i>
							<small class="text-muted">{{ categoriaSelezionata.NOME }}</small>
						</div>

						<!-- Sezioni dinamiche -->
						<template v-for="section in orderedSections" :key="section.key">
							<h5 class="text-primary d-flex justify-content-between align-items-center mt-3" @click="section.toggle()" style="cursor: pointer;">
								<span>{{ section.label }} ({{ section.tasks.length }})</span>
								<i :class="section.show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
							</h5>

							<transition name="expand-fade">
								<div v-show="section.show">
									<div v-for="task in section.tasks" :key="task.ID_TASK" class="card mb-2" draggable="true" @dragstart="expandedTaskId = task.ID_TASK" @click="toggleTask(task.ID_TASK)" :style="{ cursor: 'pointer' }">
										<div class="card-body p-1" style="height: 100% !important;">
											<!-- Riga principale -->
											<div class="d-flex align-items-center justify-content-between">
												<div class="d-flex align-items-center gap-2">
													<span
														v-if="$root.isGod && task.UTENTI_ASSEGNATI?.length == 1 && task.UTENTI_ASSEGNATI[0].ID_UTENTE == $root.utente.ID_UTENTE">
														<input type="checkbox" class="form-check-input me-1"
															style="width: 15px; height: 15px;"
															:checked="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : false"
															:disabled="false"
															@change.stop="toggleCompletamento(task)" />
													</span>

													<span v-else-if="$root.isGod">
														<button class="btn btn-sm btn-outline-success me-1"
															@click.stop="toggleCompletamento(task)"
															title="Completa task per uno o più utenti">
															<i class="fa fa-check-square-o"></i>
														</button>
													</span>

													<span v-else>
														<input type="checkbox" class="form-check-input me-1"
															style="width: 15px; height: 15px;"
															:checked="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : false"
															:disabled="task.UTENTE_LOGGATO ? task.UTENTE_LOGGATO.COMPLETATA == 1 : true"
															@change.stop="toggleCompletamento(task)" />
													</span>
													<h6 class="fs-sm mb-0 ms-1" :style="{ textDecoration: task.UTENTE_LOGGATO?.COMPLETATA ? 'line-through' : 'none' }">
														{{ task.TITOLO }}
													</h6>
												</div>
												<div class="d-flex align-items-center gap-2">
													<span class="float-end fs-sm"><i class="fa fa-clock me-1"></i>{{ filters.formatDate(task.DATA_SCADENZA) }}</span>
													<a href="#" :class="task.UTENTE_LOGGATO?.FISSATA ? 'text-warning' : 'text-muted'" @click.stop.prevent="toggleFissata(task, task.UTENTE_LOGGATO)" :title="task.UTENTE_LOGGATO?.FISSATA ? 'Sblocca dalla cima' : 'Fissa in cima'">
														<i :class="task.UTENTE_LOGGATO?.FISSATA ? 'fa fa-ban' : 'fa fa-thumbtack'"></i>
													</a>
												</div>
											</div>

											<!-- Priorità e Scadenza -->
											<span class="badge badge-xs" v-bind:class="getPriorityColorText(task.PRIORITY)">
												<span class="dotW rounded-pill p-1 me-1" :class="getPriorityColorCircle(task.PRIORITY)"></span> 
												{{ getPriority(task.PRIORITY) }}	
											</span>

											<!-- Sezione espandibile -->
											<transition name="expand-fade">
												<div v-show="expandedTaskId == task.ID_TASK" class="mt-3 small text-muted text-center">
													<!-- Descrizione -->
													<p class="mb-1">{{ task.DESCRIZIONE }}</p>
													<!-- Sezione Condivisa -->
													<div v-if="task.CONDIVISO == 1 && task.UTENTI_ASSEGNATI.length > 0">
														<div class="d-flex flex-column align-items-center" style="gap: 0.5rem;">

															<p class="mb-0"><i class="fa fa-users me-1"></i>Condivisa con:</p>

															<div class="d-flex align-items-center flex-wrap" v-if="activeTab == 'Condivise'" style="gap: 0.3rem;">
																<div v-for="utente in task.UTENTI_ASSEGNATI" :key="utente.ID_UTENTE" class="d-flex align-items-center avatar-wrapper" :class="{ 'expanded': avatarEspansi[task.ID_TASK] == utente.ID_UTENTE }" @click.stop="toggleAvatar(task.ID_TASK, utente.ID_UTENTE)">
																	<img v-if="utente.URL_AVATAR" :src="utente.URL_AVATAR" alt="avatar" class="avatar-img" />
																	<i v-else class="fa fa-user text-secondary avatar-img d-flex align-items-center justify-content-center"></i>
																	<transition name="fade-expand">
																		<small v-if="avatarEspansi[task.ID_TASK] == utente.ID_UTENTE" class="ms-2 username" :style="{ textDecoration: utente.COMPLETATA ? 'line-through' : 'none' }">
																			@{{ utente.USERNAME }}
																		</small>
																	</transition>
																</div>
															</div>
														</div>
													</div>
												</div>
											</transition>

										</div>
									</div>
								</div>
							</transition>
						</template>
					</div>

					<transition name="slide-fade">
						<div v-if="mostraOffcanvasInterno" class="offcanvas-interno">
							<div class="offcanvas-header d-flex justify-content-between align-items-center mb-2">
								<strong class="me-auto">{{ titoloOffcanvas }}</strong>
								<button type="button" class="btn-close" @click="mostraOffcanvasInterno = false"></button>
							</div>

							<div class="offcanvas-body">
								<!-- FILTRI AVANZATI -->
								<div v-if="titoloOffcanvas == 'Filtri Avanzati'">
									<div class="form-group mb-2">
										<label>Utente:</label>
										<input class="form-control form-control-sm" placeholder="Denominazione"
											type="text" style="width:150px" v-model="search.UTENTE.VALUE"
											autocomplete="off">
									</div>

									<div class="form-group mb-2">
										<label>Titolo:</label>
										<input class="form-control form-control-sm" placeholder="Denominazione"
											type="text" style="width:150px" v-model="search.TITOLO.VALUE"
											autocomplete="off">
									</div>

									<div class="form-group mb-2">
										<label>Descrizione:</label>
										<input class="form-control form-control-sm" placeholder="Denominazione"
											type="text" style="width:150px" v-model="search.DESCRIZIONE.VALUE"
											autocomplete="off">
									</div>

									<div class="form-group mb-2">
										<label>Priorità:</label>
										<select class="form-control form-control-sm" style="width:150px"
											v-model="search.PRIORITY.VALUE">
											<option value="">Nessuno</option>
											<option value="0">Bassa</option>
											<option value="1">Media</option>
											<option value="2">Alta</option>
										</select>
									</div>

									<div class="form-group mb-2">
										<label>Data Scadenza:</label>
										<Datepicker placeholder="Data scadenza" :dim="'sm'" style="width:150px"
											v-model="search.DATA_SCADENZA.VALUE" autocomplete="off" model-type="dd/MM/yyyy HH:mm" :formats="{ input: 'dd/MM/yyyy HH:mm' }" />
									</div>
								</div>

								<!-- SELEZIONA CATEGORIA -->
								<div v-else-if="titoloOffcanvas == 'Seleziona Categoria'">
									<div class="px-3 pt-3 pb-2 border-bottom">
										<input type="text" class="form-control bg-transparent rounded-pill mb-2" placeholder="Search">
										<a href="#" class="text-primary small d-block" @click.prevent="creaCategoria">
											<i class="fa fa-plus me-1"></i> Nuova categoria
										</a>
									</div>

									<div style="overflow-y: auto; max-height: calc(100vh - 380px);">
										<div class="list-group list-group-flush pb-2">
											<ul class="nav nav-sidebar" data-nav-type="accordion">
												<li class="nav-item-header text-muted fw-bold">Principali</li>
												<li class="nav-item" v-for="cat in categorieBase" :key="cat.ID_CATEGORIA">
													<a href="#" class="nav-link" :class="{ 'bg-light border': categoriaSelezionata?.ID_CATEGORIA == cat.ID_CATEGORIA, 'border-primary': hoveredCategoryId == cat.ID_CATEGORIA }" style="border: none; background-color: transparent; cursor: pointer;" @click="selezionaCategoria(cat)">
														<i :class="['fad', cat.ICONA?.toLowerCase()]" :style="{ color: cat.COLORE, fontSize: '1.1rem', minWidth: '20px' }"></i>
														<span class="text-truncate" style="font-size: 0.95rem;">{{ cat.NOME }}</span>
													</a>
												</li>
												<li class="nav-item-header text-muted fw-bold">Le Mie Categorie</li>
												<li class="nav-item" v-for="cat in categoriePersonalizzate" :key="cat.ID_CATEGORIA">
													<a href="#" class="nav-link" :class="{ 'bg-light border': categoriaSelezionata?.ID_CATEGORIA == cat.ID_CATEGORIA, 'border-primary': hoveredCategoryId == cat.ID_CATEGORIA }" style="border: none; background-color: transparent; cursor: pointer;" @click="selezionaCategoria(cat)">
														<i :class="['fad', cat.ICONA?.toLowerCase()]" :style="{ color: cat.COLORE, fontSize: '1.1rem', minWidth: '20px' }"></i>
														<span class="text-truncate" style="font-size: 0.95rem;">{{ cat.NOME }} <small v-show="cat?.USERNAME">({{cat.USERNAME}})</small></span>
													</a>
												</li>
												<li class="nav-item-header text-muted">&nbsp;</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</transition>

					<!-- Footer -->
					<div class="card-footer" style="height: 0px; padding: 0; border: none;">
						<div class="float-start">
							<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
						</div>
						<div class="float-end">
							<button type="button" class="btn btn-primary btn-sm mt-2" @click="creaTask">
								<i class="fa fa-plus me-2" aria-hidden="true"></i> Nuova Task
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>


	<!-- MODALE PER LE TASK -->
	<ModalToDo ref="modalTodo" :task="taskSelezionata" :categories="arrayCategories" :arrayUtenti="arrayUtenti" @salva="salvaTask" />

	<!-- MODALE PER LE CATEGORIE -->
	<div class="modal fade" id="modalCategoria" tabindex="-1" aria-labelledby="modalCategoriaLabel" aria-hidden="true">
		<div class="modal-dialog modal-lg">
			<div class="modal-content rounded-3">
				<div class="modal-header">
					<h5 class="modal-title" id="modalCategoriaLabel">
						{{ categoriaSelezionata.ID_CATEGORIA > 0 ? 'Modifica Categoria' : 'Nuova Categoria' }}
					</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
				</div>
				<div class="modal-body">
					<div class="mb-3">
						<label class="form-label">Nome</label>
						<input type="text" v-model="categoriaSelezionata.NOME" class="form-control" placeholder="Nome categoria" />
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
					<button type="button" class="btn btn-primary" @click="salvaCategoria">
						{{ categoriaSelezionata.ID_CATEGORIA > 0 ? 'Salva modifiche' : 'Crea categoria' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<PromemoriaForm ref="promemoriaForm" :task="taskSelezionata" :utente="$root.utente" :valore="promemoria" @salvato="init()" @eliminato="init()"></PromemoriaForm>
	
	<div class="modal fade" id="modalCompletamento" tabindex="-1" aria-labelledby="modalCompletamento"
		aria-hidden="true">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1 class="modal-title fs-5" id="exampleModalLabel">Per conto di chi vuoi completare la task?</h1>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div v-if="(modaleCompletamentoGod.utenti).length > 0">
						<table class="table table-sm" style="overflow: auto;">
							<thead>
								<tr>
									<th style="width:30%">Completa</th>
									<th style="width:30%">Utente</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="utente in modaleCompletamentoGod.utenti" :key="utente.ID_UTENTE">
									<td>
										<input type="checkbox" :checked="utente.COMPLETATA == 1"
											@change="completaTask(modaleCompletamentoGod.task, utente)">
									</td>
									<td>{{ utente.USERNAME }}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn btn-sm btn-primary" @click="confermaCompletamentoGod()">Completa per
						tutti</button>
				</div>
			</div>
		</div>
	</div>

	<audio ref="suonoCompleta" preload="auto">
		<source src="@/assets/sounds/completed.mp3" type="audio/mpeg">
	</audio>

</template>

<script>
import ModalToDo from '@/components/ModalToDo.vue';
import Pagine from '@/components/utils/Pagine.vue';
import PromemoriaForm from '@/components/PromemoriaForm.vue';
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker';

export default {
	name: 'Task',
	components: {
		ModalToDo,
		Pagine,
		Datepicker,
		PromemoriaForm
	},
	props: {
		isDashboard: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			filters: global.filters,
			taskSelezionata: {},
			arrayTask: new Array(),
			arrayCategories: new Array(),
			categoriaSelezionata: {},
			arrayUtenti: this.$root.arrayUtentiAdmin,
			expandedTaskId: null,
			showFissate: false,
			showDaFare: false,
			showCompleted: false,
			activeTab: 'Personali', // 'Personali' o 'Condivise'
			iconeDisponibili: [
				'fa-tasks', 'fa-folder', 'fa-star', 'fa-heart', 'fa-briefcase',
				'fa-check', 'fa-calendar', 'fa-lightbulb', 'fa-book', 'fa-music'
			],
			hoveredCategoryId: null,
			search: {
				PAGINATION: { LENGTH: 0, PAGE_NUMBER: 1, PAGE_SIZE: 50 },
				UTENTE: { TYPE: 'TEXT', VALUE: '' },
				TITOLO: { TYPE: 'TEXT', VALUE: '' },
				DESCRIZIONE: { TYPE: 'TEXT', VALUE: '' },
				PRIORITY: { TYPE: 'COMBO', VALUE: '' },
				DATA_SCADENZA: { TYPE: 'DATETIME', VALUE: '' },
			},
			avatarEspansi: {},
			mostraOffcanvasInterno: false,
			titoloOffcanvas: '',
			ordinamento: 'DATA_SCADENZA_DESC',
			// viene riempito dinamicamente
			metaConf: [],
			ordinaKeys: ['ORDINE_FISSATE', 'ORDINE_DA_FARE', 'ORDINE_COMPLETATE'],
			promemoria: {},
			modaleCompletamentoGod: {
				task: null,
				utenti: []
			},
			hoverUtente: null
		};
	},

	methods: {
		salvaOpzioni() {
			const valori = this.ordinaKeys
				.map(k => this.$root.confUtente[k])
				.filter(v => v !== '' && v !== null && v !== undefined);

			const duplicati = valori.some((val, idx) => valori.indexOf(val) !== idx);

			if (duplicati) {
				utils.alert.danger("Attenzione: le posizioni devono essere tutte diverse (1°, 2°, 3°).");
				return;
			}

			const payload = {
				...this.$root.confUtente,
				FK_ID_UTENTE: this.$root.utente.ID_UTENTE
			};

			utils.ajax('todo/conf/update', payload, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Configurazioni salvate con successo.");
					filters.closePopUp('modalOpzioniTask');
				} else {
					utils.alert.danger("Errore nel salvataggio: " + response.messaggio);
				}
			});
		},

		toggleAvatar(taskId, userId) {
			if (this.avatarEspansi[taskId] == userId) {
				this.avatarEspansi[taskId] = null;
			} else {
				this.avatarEspansi[taskId] = userId;
			}
		},

		apriSelezioneCategoria() {
			this.titoloOffcanvas = 'Seleziona Categoria';
			this.mostraOffcanvasInterno = true;
		},

		toggleFilterCollapse() {
			this.titoloOffcanvas = 'Filtri Avanzati';
			this.mostraOffcanvasInterno = true;
		},

		onDrop(evt, idCategoriaDestinazione) {
			const task = evt.item.__vue__?.element;

			const categoriaDest = this.arrayCategories.find(c => c.ID_CATEGORIA == idCategoriaDestinazione);

			if (!task || !categoriaDest) return;

			if (categoriaDest.CONDIVISA == 1) {
				utils.alert.warning("Puoi spostare le task solo in categorie personali.");
				this.init(); // ripristina visivamente
				return;
			}

			// Se non cambia categoria, non fare nulla
			if (task.FK_ID_CATEGORIA == idCategoriaDestinazione) return;

			// Aggiorna nel backend
			utils.ajax('todo/task/update', { ...task, FK_ID_CATEGORIA: idCategoriaDestinazione }, (response) => {
				if (response.esito == 0) {
					this.init();
				} else {
					utils.alert.danger("Errore nello spostamento: " + response.messaggio);
				}
			});
		},

		onDropCategoria(cat) {
			if (cat.CONDIVISA == 1) {
				utils.alert.warning("Puoi spostare le task solo in categorie personali.");
				this.hoveredCategoryId = null;
				return;
			}

			const draggedTask = this.arrayTask.find(t => t.ID_TASK == this.expandedTaskId); // o task attualmente drag
			if (!draggedTask) return;

			if (draggedTask.FK_ID_CATEGORIA == cat.ID_CATEGORIA) return;

			utils.ajax('todo/task/update', { ...draggedTask, FK_ID_CATEGORIA: cat.ID_CATEGORIA }, (response) => {
				if (response.esito == 0) {
					this.init();
				} else {
					utils.alert.danger("Errore nello spostamento: " + response.messaggio);
				}
			});
			this.expandedTaskId = null;
			this.hoveredCategoryId = null;

		},

		toggleTask(taskId) {
			this.expandedTaskId = this.expandedTaskId == taskId ? null : taskId;
		},

		toggleCompletamento(task) {
			if (
				this.$root.isGod &&
				task.UTENTI_ASSEGNATI?.length == 1 &&
				task.UTENTI_ASSEGNATI[0].ID_UTENTE == this.$root.utente.ID_UTENTE
			) {
				this.completaTask(task, task.UTENTE_LOGGATO);
				return;
			}

			if (this.$root.isGod) {
				this.modaleCompletamentoGod.task = task;
				this.modaleCompletamentoGod.utenti = task.UTENTI_ASSEGNATI.map(u => ({
					...u,
					SELEZIONATO: false
				}));
				this.filters.openPopUp('modalCompletamento');
			} else {
				this.completaTask(task, task.UTENTE_LOGGATO);
			}
		},

		completaTask(task, utente, statoManuale = null) {
			const nuovoStato = statoManuale !== null ? statoManuale : !utente.COMPLETATA;

			if (nuovoStato && this.$root.confUtente.SUONO == 1) {
				const audio = this.$refs.suonoCompleta;
				if (audio) {
					try {
						audio.pause();
						audio.currentTime = 0;
						audio.play();
					} catch (e) {
						console.warn('Errore audio:', e);
					}
				}
			}

			utils.ajax('todo/task/completa', {
				ID_TASK: task.ID_TASK,
				ID_UTENTE: utente.ID_UTENTE,
				COMPLETATA: nuovoStato ? 1 : 0,
				isGod: this.$root.isGod
			}, (response) => {
				if (response.esito == 0) {
					utente.COMPLETATA = nuovoStato ? 1 : 0;
				} else {
					utils.alert.danger("Errore: " + response.messaggio);
				}
			});
		},

		confermaCompletamentoGod() {
			const utenti = this.modaleCompletamentoGod.utenti;

			if (!utenti || utenti.length == 0) {
				utils.alert.warning("Nessun utente assegnato alla task.");
				return;
			}

			const idTask = this.modaleCompletamentoGod.task.ID_TASK;
			const idUtenti = utenti.map(u => u.ID_UTENTE);

			utils.ajax('todo/task/completa/multiple', {
				ID_TASK: idTask,
				ID_UTENTI: idUtenti,
				COMPLETATA: 1,
				isGod: true
			}, (response) => {
				if (response.esito == 0) {
					utenti.forEach(u => u.COMPLETATA = 1);
					this.modaleCompletamentoGod.task.COMPLETATA = 1;
					if (this.$refs.suonoCompleta && this.$root.confUtente.SUONO == 1) {
						const audio = this.$refs.suonoCompleta;
						try {
							audio.pause();
							audio.currentTime = 0;
							audio.play();
						} catch (e) {
							console.warn('Errore audio:', e);
						}
					}
					this.filters.closePopUp('modalCompletamento');
				} else {
					utils.alert.danger("Errore: " + response.messaggio);
				}
			});
		},



		toggleFissata(task, utente) {
			const nuovaFissata = !utente.FISSATA;
			utils.ajax('todo/task/fissa', {
				ID_TASK: task.ID_TASK,
				ID_UTENTE: utente.ID_UTENTE,
				FISSATA: nuovaFissata ? 1 : 0
			}, (response) => {
				if (response.esito == 0) {
					utente.FISSATA = nuovaFissata ? 1 : 0;
				} else {
					utils.alert.danger("Errore: " + response.messaggio);
				}
			});
		},


		onChangeCategoria(task) {
			const nuovaCategoria = task.FK_ID_CATEGORIA;
			task.isGod = this.$root.isGod;
			utils.ajax('todo/task/update', { ...task }, (response) => {
				if (response.esito == 0) {
					// Se stai visualizzando una categoria specifica, aggiornala
					if (this.categoriaSelezionata?.ID_CATEGORIA) {
						this.init(this.categoriaSelezionata.ID_CATEGORIA);
					} else {
						this.init(); // altrimenti carica tutte
					}
				} else {
					utils.alert.danger("Errore nello spostamento: " + response.messaggio);
				}
			});
		},


		init(_idCategoria = null) {
			if (_idCategoria !== null) {
				this.categoriaSelezionata = this.arrayCategories.find(c => c.ID_CATEGORIA == _idCategoria) || {};
			} else {
				this.categoriaSelezionata = {};
			}

			const idCategoriaParam = _idCategoria !== null ? _idCategoria : undefined;

			const idUtenteLoggatoParam = this.$root.isGod
				? this.$root.utente.ID_UTENTE
				: this.$root.utente.ID_UTENTE;

			utils.ajax('todo/tasks/get', {
				FK_ID_CATEGORIA: idCategoriaParam,
				ID_UTENTE_LOGGATO: idUtenteLoggatoParam,
				isGod: this.$root.isGod
			}, (response) => {
				if (response.esito == 0) {
					this.arrayTask = response.data;
					this.showDaFare = true;
				} else {
					console.log('Errore durante il caricamento delle task: ' + response.messaggio);
				}
			});
		},

		creaTask() {
			this.taskSelezionata = {};
			this.$refs.modalTodo.createTask();
		},

		modificaTask(task) {
			this.taskSelezionata = { ...task };
			this.$refs.modalTodo.editTask();
		},

		eliminaTask(task) {
			if (this.filters.getCustomOpzione('ELIMINA PROMEMORIA') == 1) {
				utils.alert.confirm("Sei sicuro di voler eliminare la task selezionata?", () => {
					utils.ajax('todo/task/delete', { ID_TASK: task.ID_TASK }, (response) => {
						if (response.esito == 0) {
							this.init();
							utils.alert.success("Task eliminata con successo.");
						} else {
							utils.alert.danger("Errore nell'eliminazione della task.");
						}
					});
				}, this.$root);
			} else {
				utils.ajax('todo/task/delete', { ID_TASK: task.ID_TASK }, (response) => {
					if (response.esito == 0) {
						this.init();
						utils.alert.success("Task eliminata con successo.");
					} else {
						utils.alert.danger("Errore nell'eliminazione della task.");
					}
				});
			}
		},

		salvaTask(task) {
			task.CONDIVISO = task.CONDIVISO == 1 ? 1 : 0;
			task.FK_ID_UTENTE = this.$root.utente.ID_UTENTE;
			task.isGod = this.$root.isGod;
			if (task.ID_TASK > 0) {
				utils.ajax('todo/task/update', task, (response) => {
					if (response.esito == 0) {
						this.init();
						this.filters.closePopUp('modalTask');
					} else {
						this.filters.closePopUp('modalTask');
						console.log('Errore durante l\'aggiornamento della task: ' + response.messaggio);
					}
				});
			} else {
				utils.ajax('todo/task/insert', task, (response) => {
					if (response.esito == 0) {
						this.init();
						this.filters.closePopUp('modalTask');
					} else {
						this.filters.closePopUp('modalTask');
						console.log('Errore durante la creazione della task: ' + response.messaggio);
					}
				});
			}
		},

		getPriority(priority) {
			switch (priority) {
				case 0: return 'normale'; // #28a745 verde - bassa
				case 1: return 'media'; // #ffc107 giallo - media
				case 2: return 'alta'; // #dc3545 rosso - alta
				default: return 'bassa'; // #6c757dgrigio default
			}
		},

		getPriorityColorCircle(priority) {
			switch (priority) {
				case 0: return 'bg-success'; // #28a745 verde - bassa
				case 1: return 'bg-warning'; // #ffc107 giallo - media
				case 2: return 'bg-danger'; // #dc3545 rosso - alta
				default: return 'bg-dark'; // #6c757dgrigio default
			}
		},

		getPriorityColorText(priority) {
			switch (priority) {
				case 0: return 'text-success'; // #28a745 verde - bassa
				case 1: return 'text-warning'; // #ffc107 giallo - media
				case 2: return 'text-danger'; // #dc3545 rosso - alta
				default: return 'text-dark'; // #6c757dgrigio default
			}
		},

		// METODI PER LA CATEGORIA
		selezionaCategoria(cat) {
			this.categoriaSelezionata = cat;
			this.init(cat.ID_CATEGORIA);
		}
		,
		creaCategoria() {
			this.categoriaSelezionata = { ID_CATEGORIA: 0, FK_ID_UTENTE: this.$root.utente.ID_UTENTE, FLG_PRIMARY : 1 };
			filters.openPopUp('modalCategoria');
		},
		modificaOpzione() {
			filters.openPopUp('modalOpzioniTask');
		},
		salvaCategoria() {
			if (!this.categoriaSelezionata.NOME) {
				alert("Nome categoria obbligatorio");
				return;
			}
			const endpoint = this.categoriaSelezionata.ID_CATEGORIA > 0
				? 'todo/categoria/update'
				: 'todo/categoria/insert';

			utils.ajax(endpoint, this.categoriaSelezionata, (response) => {
				if (response.esito == 0) {
					utils.alert.success("Categoria salvata con successo");
					this.loadCategorie();
					filters.closePopUp('modalCategoria');
				} else {
					utils.alert.danger("Errore nel salvataggio: " + response.messaggio);
				}
			});
		},
		loadCategorie() {
			utils.ajax('todo/categorie/get', { ID_UTENTE: this.$root.utente.ID_UTENTE, isGod : this.$root.isGod }, (response) => {
				if (response.esito == 0) {
					this.arrayCategories = response.data;
				}
			});
		},
		loadConf() {
			utils.ajax('todo/conf/get', { ID_UTENTE: this.$root.utente.ID_UTENTE }, (response) => {
				if (response.esito == '0') {
					this.metaConf = response.data;
					// Costruisce oggetto $root.confUtente: { SUONO: 0, PROMEMORIA: 1, ... }
					this.metaConf.forEach(c => {
						this.$root.confUtente[c.key] = c.value;
					});
				}
			});
		},
		toggleOrdinamento() {
			const opzioni = [
				'DATA_SCADENZA_DESC',
				'DATA_SCADENZA_ASC',
				'TITOLO_ASC',
				'TITOLO_DESC'
			];
			const index = opzioni.indexOf(this.ordinamento);
			this.ordinamento = opzioni[(index + 1) % opzioni.length];
			this.ordinaTask();
		},

		ordinaTask() {
			const compare = {
				'TITOLO_ASC': (a, b) => a.TITOLO.localeCompare(b.TITOLO),
				'TITOLO_DESC': (a, b) => b.TITOLO.localeCompare(a.TITOLO),
				'DATA_SCADENZA_ASC': (a, b) => new Date(a.DATA_SCADENZA) - new Date(b.DATA_SCADENZA),
				'DATA_SCADENZA_DESC': (a, b) => new Date(b.DATA_SCADENZA) - new Date(a.DATA_SCADENZA),
			};

			this.tasksFissate.sort(compare[this.ordinamento]);
			this.tasksDaFare.sort(compare[this.ordinamento]);
			this.tasksCompletate.sort(compare[this.ordinamento]);
		},

		dettagliItemPerUtente(task, idUtente) {
			if (!task.ITEM_ASSEGNATI) return [];
			return task.ITEM_ASSEGNATI
				.filter(i => i.ID_UTENTE == idUtente)
				.map(i => ({
					item: i.FK_ID_ITEM,
					completata: i.COMPLETATA == 1,
					modulo: i.FK_ID_MODULO
				}));
		},
		showTooltipIfItem(task, idUtente) {
			const haItem = task.ITEM_ASSEGNATI?.some(i => i.ID_UTENTE == idUtente);
			this.hoverUtente = haItem ? idUtente : null;
		},

		formatItemsFormatted(items) {
			if (!items || !items.length) return '';
			const moduli = {};
			for (const el of items) {
				if (el.ID_UTENTE !== this.$root.utente.ID_UTENTE) continue;

				const mod = el.FK_ID_MODULO;
				if (!moduli[mod]) moduli[mod] = [];
				moduli[mod].push({
					id: el.FK_ID_ITEM,
					completata: el.COMPLETATA == 1
				});
			}

			const primoModulo = Object.keys(moduli)[0];
			if (!primoModulo) return '';

			const htmlItems = moduli[primoModulo]
				.map(el => {
					return el.completata
						? `<span style="text-decoration: line-through">${el.id}</span>`
						: `<span>${el.id}</span>`;
				})
				.join(',');

			return `Modulo ${primoModulo}: ${htmlItems}`;
		},
		completaItem(task, idUtente, idItem, completata) {
			const itemInfo = task.ITEM_ASSEGNATI.find(
				i => i.FK_ID_ITEM == idItem && i.ID_UTENTE == idUtente
			);
			if (!itemInfo) return;

			const payload = {
				FK_ID_TASK: task.ID_TASK,
				FK_ID_ITEM: idItem,
				FK_ID_MODULO: itemInfo.FK_ID_MODULO,
				FK_ID_UTENTE: idUtente,
				COMPLETATA: completata ? 1 : 0,
				isGod: this.$root.isGod
			};

			utils.ajax('todo/task/item/completa', payload, (response) => {
				if (response.esito == 0) {
					utils.alert.success('Item aggiornato');
					task.ITEM_ASSEGNATI = task.ITEM_ASSEGNATI.map(i =>
						i.FK_ID_ITEM == idItem && i.ID_UTENTE == idUtente
							? { ...i, COMPLETATA: completata ? 1 : 0 }
							: i
					);
				} else {
					utils.alert.danger(response.messaggio || 'Errore');
				}
			});
		},

		gestisciPromemoria(task) {
			this.taskSelezionata = task;
			this.$refs.promemoriaForm.openPromemoria(task);
		},


	},

	created() {	
		this.loadCategorie();
		this.init(null); // <-- carica tutte le task
	},

	computed: {
		totalePersonali() {
			return this.arrayTask.filter(task =>
				task.CONDIVISO == 0 &&
				task.UTENTE_LOGGATO &&
				task.UTENTE_LOGGATO.ID_UTENTE == this.$root.utente.ID_UTENTE
			).length;
		},
		totaleCondivise() {
			return this.arrayTask.filter(task =>
				task.CONDIVISO == 1 &&
				task.UTENTE_LOGGATO &&
				task.UTENTE_LOGGATO.ID_UTENTE == this.$root.utente.ID_UTENTE
			).length;
		},
		tasksDaFare() {
			const isGod = this.$root.isGod == true;

			return this.arrayTask.filter(task =>
				task.CONDIVISO == (this.activeTab == 'Condivise' ? 1 : 0) &&
				(
					isGod
						? task.UTENTI_ASSEGNATI?.some(u => u.COMPLETATA == 0 && u.FISSATA != 1)
						: task.UTENTE_LOGGATO &&
						task.UTENTE_LOGGATO.ID_UTENTE == this.$root.utente.ID_UTENTE &&
						task.UTENTE_LOGGATO.COMPLETATA == 0 &&
						task.UTENTE_LOGGATO.FISSATA != 1
				)
			);
		},
		tasksCompletate() {
			const isGod = this.$root.isGod == true;

			return this.arrayTask.filter(task =>
				task.CONDIVISO == (this.activeTab == 'Condivise' ? 1 : 0) &&
				(
					isGod
						? task.UTENTI_ASSEGNATI?.some(u => u.COMPLETATA == 1 && u.FISSATA != 1)
						: task.UTENTE_LOGGATO &&
						task.UTENTE_LOGGATO.ID_UTENTE == this.$root.utente.ID_UTENTE &&
						task.UTENTE_LOGGATO.COMPLETATA == 1 &&
						task.UTENTE_LOGGATO.FISSATA != 1
				)
			);
		},

		tasksFissate() {
			const isGod = this.$root.isGod == true;

			return this.arrayTask.filter(task =>
				task.CONDIVISO == (this.activeTab == 'Condivise' ? 1 : 0) &&
				(
					isGod
						? task.UTENTI_ASSEGNATI?.some(u => u.FISSATA == 1)
						: task.UTENTE_LOGGATO &&
						task.UTENTE_LOGGATO.ID_UTENTE == this.$root.utente.ID_UTENTE &&
						task.UTENTE_LOGGATO.FISSATA == 1
				)
			);
		},
		filteredDaFare() {
			const q = this.search.UTENTE.VALUE.trim().toLowerCase();
			if (!q) return this.tasksDaFare;

			return this.tasksDaFare.filter(t =>
				t.UTENTI_ASSEGNATI?.some(u =>
					u.USERNAME.toLowerCase().includes(q)
				)
			);
		},
		filteredCompletate() {
			const q = this.search.UTENTE.VALUE.trim().toLowerCase();
			if (!q) return this.tasksCompletate;

			return this.tasksCompletate.filter(t =>
				t.UTENTI_ASSEGNATI?.some(u =>
					u.USERNAME.toLowerCase().includes(q)
				)
			);
		},
		filteredFissate() {
			const q = this.search.UTENTE.VALUE.trim().toLowerCase();
			if (!q) return this.tasksFissate;

			return this.tasksFissate.filter(t =>
				t.UTENTI_ASSEGNATI?.some(u =>
					u.USERNAME.toLowerCase().includes(q)
				)
			);
		},

		paginatedList() {
			const cfg1 = JSON.parse(JSON.stringify(this.search));
			const cfg2 = JSON.parse(JSON.stringify(this.search));
			const cfg3 = JSON.parse(JSON.stringify(this.search));

			let ordinamentoCampo = this.ordinamento.replace('_ASC', '').replace('_DESC', '');
			let direzione = this.ordinamento.endsWith('_DESC') ? '-' : '';
			let ordinamentoEffettivo = direzione + ordinamentoCampo;

			const isCampoData = ordinamentoCampo.toLowerCase().includes('data') || ordinamentoCampo.toLowerCase().includes('scadenza');

			// Funzione per convertire "gg/mm/aaaa" → Date
			function parseItalianDate(str) {
				if (!str || typeof str !== 'string') return new Date(0); // fallback per valori vuoti
				const parts = str.split('/');
				if (parts.length !== 3) return new Date(0);
				const [gg, mm, aaaa] = parts;
				return new Date(`${aaaa}-${mm}-${gg}`); // ISO format
			}

			if (isCampoData) {
				const customSorter = (a, b) => {
					const dateA = parseItalianDate(a[ordinamentoCampo]);
					const dateB = parseItalianDate(b[ordinamentoCampo]);

					if (dateA < dateB) return direzione == '-' ? 1 : -1;
					if (dateA > dateB) return direzione == '-' ? -1 : 1;
					return 0;
				};

				return {
					daFare: utils.inGrid([...this.tasksDaFare].sort(customSorter), cfg1),
					completate: utils.inGrid([...this.tasksCompletate].sort(customSorter), cfg2),
					fissate: utils.inGrid([...this.tasksFissate].sort(customSorter), cfg3)
				};
			} else {
				return {
					daFare: utils.inGrid(this.tasksDaFare, cfg1, ordinamentoEffettivo),
					completate: utils.inGrid(this.tasksCompletate, cfg2, ordinamentoEffettivo),
					fissate: utils.inGrid(this.tasksFissate, cfg3, ordinamentoEffettivo)
				};
			}
		},
		orderedSections() {
			const sections = [
				{ key: 'fissate', label: 'Fissate', tasks: this.paginatedList.fissate.arr, show: this.showFissate, toggle: () => this.showFissate = !this.showFissate },
				{ key: 'daFare', label: 'Da Fare', tasks: this.paginatedList.daFare.arr, show: this.showDaFare, toggle: () => this.showDaFare = !this.showDaFare },
				{ key: 'completate', label: 'Completate', tasks: this.paginatedList.completate.arr, show: this.showCompleted, toggle: () => this.showCompleted = !this.showCompleted }
			];

			// Ordina secondo ORDINE_FISSATE / DA_FARE / COMPLETATE
			const ordering = {
				fissate: parseInt(this.filters.getCustomOpzione('ORD PROM FISSATE') || 0),
				daFare: parseInt(this.filters.getCustomOpzione('ORD PROM DA FARE') || 0),
				completate: parseInt(this.filters.getCustomOpzione('ORD PROM COMPLETATE') || 0)
			};

			return sections.sort((a, b) => ordering[a.key] - ordering[b.key]);
		},

		isCurrentRouteToDo() {
			return this.$route.path == '/todo';
		},
		ordinamentoLabel() {
			switch (this.ordinamento) {
				case 'TITOLO_ASC': return 'Titolo (A-Z)';
				case 'TITOLO_DESC': return 'Titolo (Z-A)';
				case 'DATA_SCADENZA_ASC': return 'Scadenza ↑';
				case 'DATA_SCADENZA_DESC': return 'Scadenza ↓';
				default: return 'Nessuno';
			}
		},

		categorieBase() {
			return this.arrayCategories.filter(cat => cat.FLG_PRIMARY == 0);
		},
		categoriePersonalizzate() {
			return this.arrayCategories.filter(cat => cat.FLG_PRIMARY == 1);
		}

	}
};

</script>


<style scoped>
.file-card {
	background-color: transparent;
	border: none;
	box-shadow: none;
	transition: all 0.2s ease-in-out;
	cursor: pointer;
}

.file-card:hover {
	border: 1px solid #0d6efd;
	background-color: rgba(13, 110, 253, 0.05);
}

.file-card.selected {
	background-color: rgba(13, 110, 253, 0.1);
	border: 2px solid #0d6efd;
}

.selection-bar {
	background-color: #f0f0f0;
	border-radius: 6px;
	padding: 4px 8px;
	border: 1px solid #ddd;
	box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
}

.uploaded-preview-bar::-webkit-scrollbar {
	height: 6px;
}

.uploaded-preview-bar::-webkit-scrollbar-thumb {
	background: #ccc;
	border-radius: 3px;
}

.icon-option:hover {
	border-color: #0d6efd;
	background-color: #e7f1ff;
}

.list-group-item:hover {
	background-color: #f8f9fa;
	transition: background-color 0.2s ease;
}

.list-group-item.border-primary {
	box-shadow: 0 0 0 2px #0d6efd inset;
}

.avatar-wrapper {
	position: relative;
	cursor: pointer;
	transition: transform 0.3s ease;
	margin-left: -12px;
	z-index: 1;
}

.avatar-wrapper.expanded {
	transform: scale(1.15);
	z-index: 10;
}

.avatar-img {
	width: 28px;
	height: 28px;
	border-radius: 50%;
	object-fit: cover;
	border: 2px solid white;
	background-color: #eaeaea;
}

.username {
	white-space: nowrap;
	font-size: 0.75rem;
	color: #333;
	background-color: #ffffff;
	padding: 2px 6px;
	border-radius: 10px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	border: 1px solid #ddd;
	position: relative;
	z-index: 11;
}


.fade-expand-enter-active,
.fade-expand-leave-active {
	transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-expand-enter-from,
.fade-expand-leave-to {
	opacity: 0;
	transform: translateX(-5px);
}

.expand-fade-enter-active,
.expand-fade-leave-active {
	transition: all 0.25s ease;
	overflow: hidden;
}

.expand-fade-enter-from,
.expand-fade-leave-to {
	max-height: 0;
	opacity: 0;
	padding-top: 0;
	padding-bottom: 0;
	margin-top: 0;
}

.expand-fade-enter-to,
.expand-fade-leave-from {
	max-height: 500px;
	opacity: 1;
	margin-top: 0.75rem;
}

.offcanvas-interno {
	position: absolute;
	top: 0;
	right: 0;
	width: 250px;
	height: 100%;
	background-color: #fff;
	border-left: 1px solid #ccc;
	box-shadow: -3px 0 6px rgba(0, 0, 0, 0.1);
	padding: 1rem;
	z-index: 10;
}

/* Effetto animazione */
.slide-fade-enter-active,
.slide-fade-leave-active {
	transition: all 0.3s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
	transform: translateX(100%);
	opacity: 0;
}
.dotW { display: inherit; width: 5px; height: 5px; position: relative; top: 1px; } 
</style>

